import { defineMessages } from 'react-intl'

export default defineMessages({
  deleteConfirmationModalDeleteButton: {
    id: 'SpaceAppBuilderFeaturesPage.DeleteConfirmationModal.deleteConfirmationModalDeleteButton',
    defaultMessage: 'Yes, Delete'
  },
  deleteConfirmationModalChangeButton: {
    id: 'SpaceAppBuilderFeaturesPage.DeleteConfirmationModal.deleteConfirmationModalChangeButton',
    defaultMessage: 'Yes, Change'
  },
  cancel: {
    id: 'SpaceAppBuilderFeaturesPage.DeleteConfirmationModal.deleteConfirmationModalCancel',
    defaultMessage: 'Cancel'
  },
  deleteConfirmationSubMessage: {
    id: 'SpaceAppBuilderFeaturesPage.DeleteConfirmationModal.deleteConfirmationSubMessage',
    defaultMessage: "This is an unrecoverable action, there's no going back!"
  }
})
